export interface ICommand { }

export class ActivatePipelineCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ActivatePipelineCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string

	constructor (id: string, organizationUnitId: string, updatedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ActivatePipelineCommandV1, TCh.Domain.Integrations'
	}

}

export class AddPropertyNameMappingCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.AddPropertyNameMappingCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	NameForConnector: string
	NameForDataset: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, nameForConnector: string, nameForDataset: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.NameForConnector = nameForConnector
		this.NameForDataset = nameForDataset
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.AddPropertyNameMappingCommandV1, TCh.Domain.Integrations'
	}

}

export class AttachConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.AttachConnectorCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	ConnectorId: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, connectorId: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.ConnectorId = connectorId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.AttachConnectorCommandV1, TCh.Domain.Integrations'
	}

}

export class AttachDatasetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.AttachDatasetCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	DatasetId: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, datasetId: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.DatasetId = datasetId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.AttachDatasetCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeApplyChangesModeCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangeApplyChangesModeCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	ApplyChangesMode: any

	constructor (id: string, organizationUnitId: string, updatedBy: string, applyChangesMode: any)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.ApplyChangesMode = applyChangesMode
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangeApplyChangesModeCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeDataStreamCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangeDataStreamCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	DataStream: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, dataStream: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.DataStream = dataStream
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangeDataStreamCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeIdPropertyNameForConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNameForConnectorCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	IdPropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, idPropertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.IdPropertyName = idPropertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNameForConnectorCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeIdPropertyNameForDatasetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNameForDatasetCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	IdPropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, idPropertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.IdPropertyName = idPropertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNameForDatasetCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeIdPropertyNamesForConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNamesForConnectorCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	IdPropertyNames: any

	constructor (id: string, organizationUnitId: string, updatedBy: string, idPropertyNames: any)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.IdPropertyNames = idPropertyNames
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNamesForConnectorCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangeIdPropertyNamesForDatasetCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNamesForDatasetCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	IdPropertyNames: any

	constructor (id: string, organizationUnitId: string, updatedBy: string, idPropertyNames: any)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.IdPropertyNames = idPropertyNames
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangeIdPropertyNamesForDatasetCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangePipelineInternalConnectorTriggerCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangePipelineInternalConnectorTriggerCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	InternalConnectorTrigger: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, internalConnectorTrigger: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.InternalConnectorTrigger = internalConnectorTrigger
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangePipelineInternalConnectorTriggerCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangePipelineTimeTriggerRecurrencyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangePipelineTimeTriggerRecurrencyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	TimeTriggerRecurrency: any | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, timeTriggerRecurrency: any | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.TimeTriggerRecurrency = timeTriggerRecurrency
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangePipelineTimeTriggerRecurrencyCommandV1, TCh.Domain.Integrations'
	}

}

export class ChangePipelineTriggerOnRunCompletedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ChangePipelineTriggerOnRunCompletedCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	TriggerOnRunCompleted: string | null

	constructor (id: string, organizationUnitId: string, updatedBy: string, triggerOnRunCompleted: string | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.TriggerOnRunCompleted = triggerOnRunCompleted
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ChangePipelineTriggerOnRunCompletedCommandV1, TCh.Domain.Integrations'
	}

}

export class CreatePipelineCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.CreatePipelineCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	CreatedBy: string
	Name: string
	Description: string
	Direction: any
	TimeTriggerRecurrency: any | null

	constructor (id: string, organizationUnitId: string, createdBy: string, name: string, description: string, direction: any, timeTriggerRecurrency: any | null)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.CreatedBy = createdBy
		this.Name = name
		this.Description = description
		this.Direction = direction
		this.TimeTriggerRecurrency = timeTriggerRecurrency
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.CreatePipelineCommandV1, TCh.Domain.Integrations'
	}

}

export class DeactivatePipelineCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.DeactivatePipelineCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string

	constructor (id: string, organizationUnitId: string, updatedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.DeactivatePipelineCommandV1, TCh.Domain.Integrations'
	}

}

export class DeletePipelineCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.DeletePipelineCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	DeletedBy: string

	constructor (id: string, organizationUnitId: string, deletedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.DeletedBy = deletedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.DeletePipelineCommandV1, TCh.Domain.Integrations'
	}

}

export class ExcludePipelineConnectorPropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ExcludePipelineConnectorPropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	PropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, propertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.PropertyName = propertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ExcludePipelineConnectorPropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class ExcludePipelineDatasetPropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ExcludePipelineDatasetPropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	PropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, propertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.PropertyName = propertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ExcludePipelineDatasetPropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class ExcludePipelinePropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ExcludePipelinePropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	PropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, propertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.PropertyName = propertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ExcludePipelinePropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class IncludePipelineConnectorPropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.IncludePipelineConnectorPropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	PropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, propertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.PropertyName = propertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.IncludePipelineConnectorPropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class IncludePipelineDatasetPropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.IncludePipelineDatasetPropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	PropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, propertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.PropertyName = propertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.IncludePipelineDatasetPropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class IncludePipelinePropertyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.IncludePipelinePropertyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	PropertyName: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, propertyName: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.PropertyName = propertyName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.IncludePipelinePropertyCommandV1, TCh.Domain.Integrations'
	}

}

export class InternalConnectorTriggerCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.InternalConnectorTriggerCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	TriggeredBy: string
	TriggerName: string
	TriggerData: string

	constructor (id: string, organizationUnitId: string, triggeredBy: string, triggerName: string, triggerData: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.TriggeredBy = triggeredBy
		this.TriggerName = triggerName
		this.TriggerData = triggerData
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.InternalConnectorTriggerCommandV1, TCh.Domain.Integrations'
	}

}

export class PermanentDeletePipelineCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.PermanentDeletePipelineCommandV1, TCh.Domain.Integrations'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.PermanentDeletePipelineCommandV1, TCh.Domain.Integrations'
	}

}

export class RemovePropertyNameMappingCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.RemovePropertyNameMappingCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	NameForConnector: string
	NameForDataset: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, nameForConnector: string, nameForDataset: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.NameForConnector = nameForConnector
		this.NameForDataset = nameForDataset
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.RemovePropertyNameMappingCommandV1, TCh.Domain.Integrations'
	}

}

export class ResetPipelineRunsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.ResetPipelineRunsCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string

	constructor (id: string, organizationUnitId: string, updatedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.ResetPipelineRunsCommandV1, TCh.Domain.Integrations'
	}

}

export class SetPipelineLogLevelCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.SetPipelineLogLevelCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	LogLevel: any

	constructor (id: string, organizationUnitId: string, updatedBy: string, logLevel: any)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.LogLevel = logLevel
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.SetPipelineLogLevelCommandV1, TCh.Domain.Integrations'
	}

}

export class TimeTriggerPipelineCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.TimeTriggerPipelineCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	TriggeredBy: string

	constructor (id: string, organizationUnitId: string, triggeredBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.TriggeredBy = triggeredBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.TimeTriggerPipelineCommandV1, TCh.Domain.Integrations'
	}

}

export class TriggerPipelineManuallyCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.TriggerPipelineManuallyCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	TriggeredBy: string

	constructor (id: string, organizationUnitId: string, triggeredBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.TriggeredBy = triggeredBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.TriggerPipelineManuallyCommandV1, TCh.Domain.Integrations'
	}

}

export class TriggerPipelineQueuedRunsCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Pipelines.Commands.TriggerPipelineQueuedRunsCommandV1, TCh.Domain.Integrations'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Pipelines.Commands.TriggerPipelineQueuedRunsCommandV1, TCh.Domain.Integrations'
	}

}

